import * as React from 'react';
import * as _ from 'underscore';

import * as Globalization from '../../../_common/platform/ts/Globalization';
import { BooleanPureField } from '../../../_common/platform/tsx/BooleanField';

export interface IMarkedItemsBoolean {
    [key: string]: boolean;
}

export interface ISetting {
    key: string;
    value: string;
}

export interface IAppSettingsFlatCheckListProperties {
    value: ISetting[];
    marked: IMarkedItemsBoolean;
    showValueKeys?: boolean;

    onChange(marked: IMarkedItemsBoolean): void;
}

const MAX_VALUE_LENGTH = 200;

export function AppSettingsFlatCheckList(props: IAppSettingsFlatCheckListProperties) {
    const getMarkHandler = (key: string) => {
        return (value: boolean) => {
            const marked = _.clone(props.marked);

            if (value) {
                marked[key] = true;
            } else {
                delete marked[key];
            }

            if (typeof props.onChange === 'function') {
                props.onChange(marked);
            }
        };
    };

    // getSettingsFromState() {
    //     //return props.glob.SettingsStore.restoreAppSettingsForExport(state.settingsObj.settings);
    // }

    const getAllState = (restoredSettings?) => {
        if (restoredSettings == null) {
            restoredSettings = props.value; //getSettingsFromState();
        }

        return _.size(props.marked) == _.size(restoredSettings);
    };

    const handleOnSelectAllChange = (value: boolean) => {
        const all = getAllState(props.value);
        const marked = {};

        if (all === true) {
            // let's rest it empty: {}.
        } else {
            _.each(props.value, (value) => {
                marked[value.key] = true;
            });
        }

        if (typeof props.onChange === 'function') {
            props.onChange(marked);
        }
    };

    const list = _.map(props.value, (item) => {
        const { key } = item;
        const marked = props.marked[key] === true;

        let title = item.value;

        if (typeof title !== 'string') {
            title = JSON.stringify(title);
        }

        if (title.length > MAX_VALUE_LENGTH) {
            title = title.substring(0, MAX_VALUE_LENGTH) + '...';
        }

        let valueElement: React.JSX.Element;

        if (props.showValueKeys) {
            valueElement = (
                <div className="setting-value">
                    <span className="app-settings-equal">=</span>
                    <span>{title}</span>
                </div>
            );

            title = key;
        }

        return (
            <li key={key}>
                <div className="setting-value">
                    <BooleanPureField value={marked} title={title} onChange={getMarkHandler(key)} />
                </div>

                {valueElement}
            </li>
        );
    });

    return (
        <div className="app-settings-flat-check-list dirs-flat dirs-templates-flat">
            <div className="select-all">
                <BooleanPureField
                    value={getAllState()}
                    title={Globalization.getMessage('selectAll')}
                    onChange={handleOnSelectAllChange}
                />
            </div>

            <ul className="list-unstyled dirs-list-templates-flat" style={{ columnCount: 3 }}>
                {list}
            </ul>
        </div>
    );
}
